import { styled } from 'styled-components';

export const RadarTileContainer = styled.div`
  display: flex;
  max-height: ${({ $maxHeight }) => $maxHeight || '405px'};

  svg {
    margin-top: -${({ theme }) => theme.sizing.medium};
  }

  > div {
    flex-grow: 1;

    &:first-child {
      margin-right: ${({ theme }) => theme.sizing.medium};
    }
  }

  p {
    color: ${({ theme }) => theme.colours.ink.primary.main};
    position: absolute;
  }
`;
